export default theme => ({
  container: {
    marginTop: theme.spacing(4),
    flexDirection: 'column',
    padding: '0 10%',
    [theme.breakpoints.down('lg')]: {
      padding: '0 5%'
    }
  },
  grow: {
    flexGrow: 1
  },
  paper: {
    width: '10rem',
    height: '8rem'
  },
  detailPaper: {
    height: '20rem'
  },
  borderBottom: {
    borderBottom: '1px solid ' + theme.palette.divider
  },
  capabilityName: {
    color: theme.palette.secondary.main
  },
  headerRow: {
    cursor: 'pointer',
    backgroundColor: '#f3f3f3'
  },
  row: {
    backgroundColor: '#f3f3f3',
    '&:hover': {
      backgroundColor: theme.overrides.MuiSelected.root['&:hover'].backgroundColor + '!important',
      '& th': {
        color: theme.palette.text.primary
      }
    }
  },
  oddRow: {
    backgroundColor: theme.palette.primary.main
  },
  filter: {
    display: 'flex'
  },
  box: {
    marginBottom: '2%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  tableText: {
    fontSize: '0.7rem'
  },
  tableHeader: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    fontWeight: 'bold'
  },
  drawerPaper: {
    width: 550,
    zIndex: 1300
  },
  drawerRoot: {
    width: 0 // to allow click on the background
  },
  cell: {
    maxWidth: 175
  },
  title: {
    flex: 1
  },
  searchInput: {
    width: 250,
    marginRight: theme.spacing(1)
  },
  table: {
    border: '1px solid ' + theme.palette.divider,
    overflow: 'hidden',
    '& .MuiTableCell-footer': {
      border: 'none'
    }
  }
});
